var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bell_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 27531",
    fill: "currentColor",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40484",
    clipPath: "url(#bell_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17644",
    d: "M30.5 24.634h-1.941v-9.228A12.589 12.589 0 0017.5 2.93V1.5a1.5 1.5 0 00-3 0v1.424A12.59 12.59 0 003.406 15.406v9.228H1.5a1.5 1.5 0 000 3h10.661v.5a3.839 3.839 0 107.678 0v-.5H30.5a1.5 1.5 0 000-3M6.406 15.406a9.576 9.576 0 1119.153 0v9.228H6.406z",
    fill: "currentColor"
  }))));
}
export default SvgBell;